/**
 * Transport request lifecycle statuses.
 * Source of truth — keep in sync with sara nodes [[STATUS-TR-*]] and backend enum.
 *
 * Lives in Ship/ because the same map is consumed by RequestContainer (the
 * authoritative domain) AND by the cross-cutting dashboard in HomeContainer.
 * RequestContainer's own Contracts/RequestStatus.ts is now a thin re-export
 * of this module — domain consumers keep importing from there.
 *
 * VehicleNeedExecutor.status uses the same set of values (backend coincidence),
 * so we alias it as `ExecutorStatus` here. If backends diverge — split.
 */
export type RequestStatus =
    | 'new'
    | 'in_work'
    | 'transport_distributed'
    | 'completed'
    | 'cancelled'

export type ExecutorStatus = RequestStatus

export const REQUEST_STATUS_MAP: Record<RequestStatus, { label: string; color: string }> = {
    new: { label: 'Нова', color: '#1890ff' },
    in_work: { label: 'Взято в роботу', color: '#faad14' },
    transport_distributed: { label: 'Транспорт розподілено', color: '#722ed1' },
    completed: { label: 'Виконана', color: '#52c41a' },
    cancelled: { label: 'Скасована', color: '#ff4d4f' },
}
